module.exports = __webpack_public_path__ + "img/location.be3b094a.svg";